import React from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';

import {
  Modal,
  Button,
} from 'react-bootstrap';

const propTypes = exact({
  show: PropTypes.bool.isRequired,
  message: PropTypes.string.isRequired,
  onOkay: PropTypes.func.isRequired,
});

const LoginError = (props) => {
  const { message, onOkay, show } = props;
  return (
    <Modal show={show} onHide={() => { onOkay(); }}>
      <Modal.Header closeButton>
        <Modal.Title>Error</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        { message }
      </Modal.Body>
      <Modal.Footer>
        <Button
          bsStyle="warning"
          onClick={() => { onOkay(); }}
        >Okay
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

LoginError.propTypes = propTypes;

export default LoginError;
